import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { CSSModifier, CSSComponent } from '@odx/angular/internal';
import { injectElement } from '@odx/angular/utils';

const AvatarSize = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};

const AvatarVariant = {
    CIRCLE: 'circle',
    RECTANGLE: 'rectangle',
};

let AvatarComponent = class AvatarComponent {
    constructor() {
        this.element = injectElement();
        /**
         * The size of the avatar.
         *
         * @type {AvatarSize}
         * @default AvatarSize.SMALL
         */
        this.size = AvatarSize.SMALL;
        /**
         * The variant of the avatar.
         *
         * @type {AvatarVariant}
         * @default AvatarVariant.CIRCLE
         */
        this.variant = AvatarVariant.CIRCLE;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: AvatarComponent, isStandalone: true, selector: "odx-avatar", inputs: { size: "size", variant: "variant" }, ngImport: i0, template: "<ng-content />\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], AvatarComponent.prototype, "size", void 0);
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], AvatarComponent.prototype, "variant", void 0);
AvatarComponent = __decorate([
    CSSComponent('avatar')
], AvatarComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'odx-avatar', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content />\n" }]
        }], propDecorators: { size: [{
                type: Input
            }], variant: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { AvatarComponent, AvatarSize, AvatarVariant };
